var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM17.0636 5.0515L12.0007 10.1144L6.94729 5.06093L5.06168 6.94654L10.1151 12L5.06168 17.0535L6.94729 18.9391L12.0007 13.8856L17.0636 18.9485L18.9493 17.0629L13.8864 12L18.9493 6.93712L17.0636 5.0515Z",
    fill: "url(#paint0_linear_8038_4011)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8038_4011",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA3460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#861334"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppError);
export default __webpack_public_path__ + "static/media/App-Error.7fedad344c3067be190aad404357e75f.svg";
export { ForwardRef as ReactComponent };